import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { appConfig } from '@app/config/appConfig';
import { prepareOirRequestHeaders } from '@features/authentication/utils/authentication.utils';

export const baseQuery = fetchBaseQuery({
  baseUrl: appConfig.api.baseUrl,
  credentials: 'include',
  prepareHeaders: prepareOirRequestHeaders,
});
